import React, { createContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
//API
import { getUserProfile } from "../api";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  AuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };
  const getUserData = localStorage.getItem("user_details_json");
  const [user, setUser] = useState(JSON.parse(getUserData) || null);
  const [profile, setProfile] = useState(null);
  const [allLanguages, setAllLanguages] = useState([]);
  const [tokenExpire, setTokenExpire] = useState(false);
  const [forgetPassStatus, setForgetPassStatus] = useState(false);
  const [activeLanguage, setactiveLanguage] = useState(
    localStorage?.getItem("ACTIVE_LANGUAGE") ?? ""
  );

  async function fetchProfile() {
    const params = {
      _id: user?.userInfo?._id,
    };

    const result = await getUserProfile(params);
    if (result?.status) {
      setProfile(result?.data?.body?.userDetail);

      return result?.data?.body?.userDetail;
    } else {
      localStorage.removeItem("user_details_json");
      return null;
    }
  }

  useEffect(() => {
    // fetchProfile();
  }, []);

  const contextValue = useMemo(
    () => ({
      profile,
      setProfile,
      user,
      setUser,
      fetchProfile,
      activeLanguage,
      setactiveLanguage,
      allLanguages,
      setAllLanguages,
      forgetPassStatus,
      setForgetPassStatus,
      tokenExpire,
      setTokenExpire,
    }),
    [profile, user, activeLanguage, allLanguages, forgetPassStatus]
  );
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};
